import styled from 'styled-components';
import cuba_wallpaper from '../data/cuba_wallpaper.jpg';

// Main container for centering the content
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh; /* Full height */
  box-sizing: border-box; /* Include padding in the total width/height */
`;

// dropdown
export const Dropdown = styled.select`
  margin: 1rem 0;
  padding: 10px;
  width: 100%;
  max-width: 300px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: #fff;
  color: ${({ value }) => (value === '' ? '#888' : '#000')}; /* Grey when unselected */
`;


export const Input = styled.input`
  padding: 10px;
  width: 100%;
  max-width: 300px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;

  &::placeholder {
    color: #888; /* Match grey color */
  }
`;

// Full background wrapper
export const BackgroundWrapper = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: 
    linear-gradient(rgba(241, 245, 248, 0.8), rgba(241, 245, 248, 0.8)), 
    url(${cuba_wallpaper}) center/cover no-repeat;
`;

// Content wrapper inside the background
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;



// Header style
export const Heading = styled.h1`
  font-size: 3rem;
  color: #111111;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.3;
  text-align: center;
  max-width: 700px;
`;

// Description paragraph style
export const Description = styled.p`
  font-size: 18px;
  color: #11111;
  margin-bottom: 30px;
  text-align: center;
  line-height: 1.8;
  max-width: 600px;
`;

// Button styling
export const StartButton = styled.button`
  padding: 14px 28px;
  font-size: 18px;
  font-weight: 600;
  background-color: #007bff;
  color: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);

  &:hover {
    background-color: #0056b3;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 123, 255, 0.3);
  }

  &:focus {
    outline: none;
  }
`;

// Wrapper for the button to center it
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 12px;
`;